import tpl from './cuisinesTags.component.html';

export default {
  restrict: 'E',
  template: tpl,
  bindings: {
    onChange: '&',
    merchantTags: '<',
  },
  controller: function CuisinesTagsController(searchTagsService, UtilService, SEARCH_TAGS_TYPES) {
    const vm = this;
    vm.CUISINE_TAG_TYPE = SEARCH_TAGS_TYPES.CUISINE;

    vm.cuisines = [];
    vm.selectedTags = [];
    vm.additionalCuisines = [];
    vm.currentTag = '';

    vm.addTagsToLists = addTagsToLists;
    vm.deleteOnBackSpacePressed = deleteOnBackSpacePressed;
    vm.deleteTag = deleteTag;

    onInit();

    vm.$onChanges = function(changesObj) {
      if (changesObj.merchantTags.currentValue) {
        const merchantTags = changesObj.merchantTags.currentValue;
        merchantTags.forEach(tag => {
          if (tag.primary) {
            vm.mainCuisine = tag;
          }
          if (tag.tagType === vm.CUISINE_TAG_TYPE && !tag.primary) {
            vm.additionalCuisines.push(tag);
          }
          vm.selectedTags = merchantTags;
        });
        removeSelectedTagFromCuisinesList();
      }
    };

    function onInit() {
      getAllCuisinesTags();
    }

    function getAllCuisinesTags() {
      searchTagsService
        .getAllTags()
        .then(res => {
          if (res.data) {
            vm.cuisines = res.data.searchTags.filter(tag => tag.tagType === vm.CUISINE_TAG_TYPE);
          }
        })
        .catch(() => {
          NotificationService.error(`Can't retrieve tags`);
        });
    }

    function addTagsToLists(selectedTag, isPrimary) {
      if (!isPrimary) {
        vm.currentTag = '';
        vm.additionalCuisines.push(selectedTag);
      }
      selectedTag.primary = isPrimary;
      vm.selectedTags.push(selectedTag);

      removeSelectedTagFromCuisinesList();
      emitEventToParent();
    }

    function removeSelectedTagFromCuisinesList() {
      if (vm.selectedTags.length) {
        vm.selectedTags.forEach(selectedTag => {
          UtilService.deleteElementById(vm.cuisines, selectedTag.id);
        });
      }
    }

    function deleteOnBackSpacePressed(ev) {
      const backspace = 8;
      if (ev.keyCode === backspace && !vm.currentTag && vm.additionalCuisines.length) {
        const tagToDelete = vm.additionalCuisines.slice(-1)[0];
        deleteTag(tagToDelete);
      }
    }

    function deleteTag(selectedTag) {
      if (selectedTag.primary) {
        vm.mainCuisine = '';
      } else {
        deleteTagFromList(selectedTag, vm.additionalCuisines);
      }

      deleteTagFromList(selectedTag, vm.selectedTags);
      emitEventToParent();
    }

    function deleteTagFromList(tagToDelete, tagList) {
      const tagToDeleteIndex = tagList.indexOf(tagToDelete);
      tagList.splice(tagToDeleteIndex, 1);

      if (tagList === vm.selectedTags) {
        vm.cuisines.push(tagToDelete);
      }
    }

    function emitEventToParent() {
      vm.onChange({ selectedTags: vm.selectedTags });
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/common/tags/cuisinesTags.component.js